import { VISIBLE_TYPE, SELECT_TYPE, COLLAPSE_SIDEBAR_TYPE, EDIT_MODE_CHANGE_TYPE, 
  LOADING_TYPE, POPUP_CONTENT_CHANGE_TYPE, SEARCH_CHANGED_TYPE, SEARCH_RESULT, 
  FILTER_RESULT, SHOWING_FILTERS, WAIT_FOR_SERVER, DELETE_FEATURE, OPEN_TOUR,
  OPEN_PANEL, HIDE_POPUP, SAVE_FEATURE_GEOM, ADD_MODE_CHANGE, SET_AUTH, SHOULD_BE_SHOWN, ACCESSIBILITY } from './actions'

export const placeId = function (place) {
  // strip any html tags from the name
  return place.id
}

function placeSelector (state, action) {
  if (typeof state === 'undefined') {
    state = {places: [], selected: null, collapsed: false, editMode: false, loading: false, accessibiityVersion: false}
  }
  switch (action.type) {
    case VISIBLE_TYPE:
      return {
        ...state,
        places: action.places,
      }
    case SELECT_TYPE:
      return {
        ...state,
        selected: action.placeId
      }
    case COLLAPSE_SIDEBAR_TYPE:
      return {
        ...state,
        collapsed: action.collapsed
      }
    case EDIT_MODE_CHANGE_TYPE:
      return {
        ...state,
        editMode: action.editMode
      }
    case LOADING_TYPE:
      return {
        ...state,
        loading: action.loading
      }
    case POPUP_CONTENT_CHANGE_TYPE:
      return {
        ...state,
        popupContent: action.popupContent
      }
    case SEARCH_CHANGED_TYPE:
      return {
        ...state,
        query: action.query
      }
    case SEARCH_RESULT:
      return {
        ...state,
        searchResults: action.searchResults
      }
    case FILTER_RESULT:
      return {
        ...state,
        filteredResults: action.filteredResults
      }
    case SHOWING_FILTERS:
      return {
        ...state,
        showingFilters: action.show
      }
    case WAIT_FOR_SERVER:
      return {
        ...state,
        isWaitingForResponse: action.status
      }
    case DELETE_FEATURE:
      return {
        ...state,
        deletedFeature: action.id
      }
    case OPEN_TOUR:
      return {
        ...state,
        isTourOpened: action.isTourOpened
      }
    case OPEN_PANEL:
      return {
        ...state,
        isPanelOpened: action.isPanelOpened
      }
    case HIDE_POPUP:
      return {
        ...state,
        hidePopup: action.hidePopup
      }
    case SAVE_FEATURE_GEOM:
      return {
        ...state,
        saveFeatureGeomId: action.saveFeatureGeomId,
        savePlaceOrCluster: action.savePlaceOrCluster,
      }
    case ADD_MODE_CHANGE:
      return {
        ...state,
        addingFeature: action.addingFeature,
      }
    case SET_AUTH:
      return {
        ...state,
        authorizedUser: action.authorizedUser
      }
    case SHOULD_BE_SHOWN:
      return {
        ...state,
        shouldBeShownIds: action.ids
      }
    case ACCESSIBILITY:
      return {
        ...state,
        accessibilityVersion: action.status
      }
    default:
      return state
  }
}

export default placeSelector



// WEBPACK FOOTER //
// ./src/reducer.js